module.exports = __webpack_public_path__ + "img/yangCode.c09d35b4.jpg";